import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AdvertisementListLayer from "../components/AdvertisementListLayer";

const AdvertisementListPage = () => {
    return (
        <MasterLayout>
            <AdvertisementListLayer />
        </MasterLayout>
    );
};

export default AdvertisementListPage;
